import React, { useState } from "react";
import { BrowserRouter as Router, Route, Switch, Link, } from "react-router-dom";
import { AppBar, Toolbar, IconButton, Typography, Container, Avatar, Box, Menu, MenuItem, CssBaseline, ThemeProvider, createTheme, } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Settings } from "@mui/icons-material";

// Styles
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.scss';
import './loding.scss';

// Auth
import { AuthProvider, useAuth } from "./AuthContext";

// Sidebar + Logout
import Sidebar from "./Sidebar"; // move Sidebar into its own file for clarity
import Logout from "./Logout";

// Pages
//----------------Company Pages------------ //
import CompanyEdit from "./components/pages/Company/Edit";
//----------------Home Pages--------------- //
import HomePage from "./components/pages/Home";
//---------------- User Pages ------------- //
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
//----------------Role Pages--------------- //
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";
//----------------Location Pages-------- //
import LocationIndex from "./components/pages/Location/Index";
//---------------IncomeExpenseHead Pages--- //
import IncomeExpenseHeadIndex from "./components/pages/IncomeExpenseHead/Index";
//----------------Customer Pages----------- //
import CustomerIndex from "./components/pages/Customer/Index";
//----------------Consignment Pages-------- //
import ConsignmentIndex from "./components/pages/Consignment/Index";
//----------------Invoice Pages------------ //
import InvoiceIndex from "./components/pages/Invoice/Index";
import InvoiceCreate from "./components/pages/Invoice/Create";
import InvoiceDetails from "./components/pages/Invoice/Details";
import InvoiceEdit from "./components/pages/Invoice/Edit";
//----------------Receipt Pages------------ //
import PaymentAndReceiptCreate from "./components/pages/PaymentAndReceipts/Create";
import PaymentAndReceiptIndex from "./components/pages/PaymentAndReceipts/Index";
import PaymentAndReceiptDetails from "./components/pages/PaymentAndReceipts/Details";
import PaymentAndReceiptEdit from "./components/pages/PaymentAndReceipts/Edit";
//-----------------Report------------------//
import Ledger from "./components/pages/Reports/Ledger";
import Outstanding from "./components/pages/Reports/outstanding";
import ExpenseReport from "./components/pages/Reports/ExpenseReport";
import InvoiceReport from "./components/pages/Reports/InvoiceReport";
import DetailedInvoice from "./components/pages/Reports/InvoiceDetailsReport";
// ---------------- Theme ---------------- //
const theme = createTheme({
  palette: {
    // primary: { main: "#2F5249" },
    // secondary: { main: "#4CAF50" },
    primary: { main: "#173B45" },
    secondary: { main: "#173B45" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          textTransform: "none",
        },
      },
    },
  },
});

// ---------------- Layout ---------------- //
const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [hoverOpen, setHoverOpen] = useState(false); // sidebar hover state
  const [anchorEl, setAnchorEl] = useState(null);
  const { companyName, roleName, username } = useAuth();

  const handleMenu = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        {/* Header */}
        <AppBar position="fixed" color="primary" sx={{ zIndex: (t) => t.zIndex.drawer + 1 }} style={{ height: '55px' }}>
          <Toolbar>
            <IconButton color="inherit" onClick={() => setSidebarOpen(!sidebarOpen)}>
              <MenuIcon />
            </IconButton>

            <Typography
              variant="h6"
              sx={{ flexGrow: 1, ml: 2, fontWeight: "bold", textTransform: "uppercase" }}
            >
              <Link to="/Home" style={{ textDecoration: "none", color: "inherit" }}>
                <span style={{ fontFamily: 'Verdana, sans-serif', fontSize: '14px' }}>{companyName}</span>
              </Link>
            </Typography>

            <IconButton color="inherit" onClick={handleMenu}>
              <Avatar sx={{ bgcolor: "#4CAF50", width: 32, height: 32 }}>
                {username?.[0]}
              </Avatar>
            </IconButton>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
              <MenuItem onClick={handleClose}>
                <Settings fontSize="small" sx={{ mr: 1 }} /> Settings
              </MenuItem>
              <Logout asMenuItem onAfterLogout={handleClose} />
            </Menu>
          </Toolbar>
        </AppBar>

        {/* Sidebar */}
        {username !== "Counter" && (
          <Box
            onMouseEnter={() => setHoverOpen(true)}
            onMouseLeave={() => setHoverOpen(false)}
          >
            <Sidebar open={sidebarOpen || hoverOpen} roleName={roleName} />
          </Box>
        )}

        {/* Content */}
        <Box
          sx={{
            ml: sidebarOpen || hoverOpen ? "240px" : "60px",
            pt: 10,
            transition: "0.3s",
          }}
        >
          <Container maxWidth="xl" sx={{ mt: 2 }}>
            <Switch>
              <Route path="/" exact component={HomePage} />
              <Route path="/Home" exact component={HomePage} />
              <Route path="/RoleIndex" component={RoleIndex} />
              <Route path="/RoleDetail/:id" component={RoleDetail} />
              <Route path="/UserIndex" component={UserIndex} />
              <Route path="/UserCreate" component={UserCreate} />
              <Route path="/UserEdit/:id" component={UserEdit} />
              <Route path="/UserDetail/:id" component={UserDetail} />
              <Route path="/CustomerIndex" component={CustomerIndex} />
              <Route path="/CompanyEdit" component={CompanyEdit} />
              <Route path="/LocationIndex" component={LocationIndex} />
              <Route path="/ConsignmentIndex" component={ConsignmentIndex} />
              <Route path="/IncomeExpenseHeadIndex" component={IncomeExpenseHeadIndex} />
              <Route path="/InvoiceIndex" component={InvoiceIndex} />
              <Route path="/InvoiceCreate" component={InvoiceCreate} />
              <Route path="/InvoiceDetails/:id" component={InvoiceDetails} />
              <Route path="/InvoiceEdit/:id" component={InvoiceEdit} />
              <Route path="/PaymentAndReceiptCreate" component={PaymentAndReceiptCreate} />
              <Route path="/PaymentAndReceiptIndex" component={PaymentAndReceiptIndex} />
              <Route path="/PaymentAndReceiptDetails/:id" component={PaymentAndReceiptDetails} />
              <Route path="/PaymentAndReceiptEdit/:id" component={PaymentAndReceiptEdit} />
              <Route path="/Ledger" component={Ledger} />
              <Route path="/Outstanding" component={Outstanding} />
              <Route path="/ExpenseReport" component={ExpenseReport} />
              <Route path="/InvoiceReport" component={InvoiceReport} />
              <Route path="/DetailedInvoice" component={DetailedInvoice} />
            </Switch>
          </Container>
        </Box>
      </Router>
    </ThemeProvider>
  );
};

// ---------------- Root ---------------- //
const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Layout />
      </AuthProvider>
    </Router>
  );
};
export default App;
